export { Body1Strong, body1StrongClassNames } from './components/presets/Body1Strong/index';
